import styled from 'styled-components';
import {useHistory} from 'react-router-dom';
import {Input, InputGroup, InputLeftElement} from "@chakra-ui/react";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {ChevronLeft, LogIn, Menu, Search as LucideSearch, Settings, Shield, User} from "lucide-react";
import useModal from "../modals";
import {useBaseCommunity, useGoogleAdsEnabled, useLoggedIn} from "../store";
import {useActions} from "../app_context";
import {themecolors} from "../utils/themecolors";
import useGoBack from "../utils/use_go_back";
import {BareButton} from './button';
import 'react-spring-bottom-sheet/dist/style.css'
import Sheet from "./bottom-sheet/sheet";
import SettingsSheet from "./bottom-sheet/settings";
import AboutProfileSheet from "./bottom-sheet/about_profile";
import useHost from "../utils/host";
import CommunityModOptionsSheet from "./bottom-sheet/community_mod_options";

const Title = styled.div``;
const Wrapper = styled.div``;
const Search = styled.div``;
const GroupLeft = styled.div``;
const GroupRight = styled.div``;
const Save = styled.div``;

const TopBarIconInner = styled.div``;

const LogoTitle = styled.div``;

export const TopBarIcon = styled(({className, children, onClick, style}) => {
    return (
        <div className={className} style={style}>
            <BareButton className={className} onClick={onClick}>
                {children}
            </BareButton>
        </div>
    );
})`
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  height: 100%;
  width: 28px;
  padding: 0 20px;
  justify-content: center;

  ${BareButton} {
    padding: 0;
  }
`;

const TopBar = styled(({
                           className,
                           black,
                           style,
                           active,
                           title,
                           back,
                           settings,
                           sidebar,
                           community,
                           profile,
                           targetMessage,
                           messageTo,
                           search,
                           isSearch,
                           focus,
                           query,
                           setQuery,
                           save,
                           border: _1,
                           shadow,
                           feedTitle,
                           modTools,
                           transparentBackground = true,
                       }) => {
    const modal = useModal();
    const history = useHistory();
    const loggedIn = useLoggedIn();
    const onInputChange = (event) => {
        setQuery && setQuery(event.target.value);
    }

    const [settingsOpen, setSettingsOpen] = useState(false);
    const [profileInfoOpen, setProfileInfoOpen] = useState(false);
    const [communityModOpen, setCommunityModOpen] = useState(false);
    const handleProfile = () => {
        setProfileInfoOpen(true);
    };
    const handleSearch = () => {
        if (!isSearch) {
            history.push('/browse');
        }
    };
    const actions = useActions();
    const handleSave = () => {
        actions.saveClickedChanged(true);
        setTimeout(() => {
            actions.saveClickedChanged(false);
        }, 100);
    };
    const goBack = useGoBack();

    const baseCommunity = useBaseCommunity();

    const googleAdsEnabled = useGoogleAdsEnabled();
    const host = useHost();

    useEffect(() => {
        if (!googleAdsEnabled && (host === "scored.co" || host === "m.scored.co" ||
        host === "m.communities.win" || host === "communities.win")) {
            const scriptElement = document.createElement('script');
            scriptElement.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5433240839183569"
            scriptElement.defer = true;
            document.head.appendChild(scriptElement);
            actions.googleAdsEnabledChanged(true);
        }
    }, []);

    return (
        <header className={className} style={style}>
            {baseCommunity === "thedonald" &&
                <Helmet>
                    <link rel="manifest" href={`/community_thedonald_manifest.json`}/>
                    <link rel="icon" href="/community_thedonald_favicon.ico"/>
                    <link rel="apple-touch-icon" href="/community_thedonald_192.png"/>
                </Helmet>
            }
            <GroupLeft>
                {Boolean(sidebar) &&
                    <TopBarIcon onClick={() => modal.open('Sidebar')}>
                        <TopBarIconInner>
                            <Menu size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                }
                {Boolean(back) &&
                    <TopBarIcon onClick={goBack}>
                        <TopBarIconInner>
                            <ChevronLeft size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                }
            </GroupLeft>
            {!search && <Title>{title}</Title>}
            {!isSearch && search && community && !feedTitle && <LogoTitle>scored</LogoTitle>}
            {feedTitle && <Title>{feedTitle}</Title>}
            {search && !community && <Title>Communities</Title>}
            {isSearch &&
                <Search onClick={handleSearch}><form>
                    <InputGroup>
                        <InputLeftElement
                            pointerEvents="none"
                            style={{height: '36px', width: '50px'}}
                        > <LucideSearch size={20} /></InputLeftElement>
                        <Input focusBorderColor={'none'} type="text" value={query} autoFocus={focus} onChange={onInputChange} placeholder="Search" transitionDuration={'0'} />
                    </InputGroup>
                </form></Search>
            }
            <GroupRight>
                {modTools &&
                    <TopBarIcon onClick={() => setCommunityModOpen(true)}>
                        <TopBarIconInner>
                            <Shield size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                }
                {profile && <TopBarIcon onClick={handleProfile}>
                    <TopBarIconInner>
                        <User size={24} />
                    </TopBarIconInner>
                </TopBarIcon>}
                {!isSearch && search && Boolean(settings) && (
                    <TopBarIcon onClick={handleSearch}>
                        <TopBarIconInner>
                            <LucideSearch size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                )}
                {!isSearch && !loggedIn && (search || community) &&
                    <TopBarIcon onClick={() => history.push('/registration')}>
                        <TopBarIconInner>
                            <LogIn size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                }
                {!isSearch && Boolean(settings) && (<>
                    <TopBarIcon onClick={() => setSettingsOpen(true) }>
                        <TopBarIconInner>
                            <Settings size={24} />
                        </TopBarIconInner>
                    </TopBarIcon>
                </>)}
                {save &&
                    <BareButton onClick={handleSave} style={{height: '36px'}}>
                        <Save>{save.length > 0 ? save : 'Save'}</Save>
                    </BareButton>
                }
            </GroupRight>
            {profileInfoOpen && <Sheet onClose={() => setProfileInfoOpen(false) } canMaxHeight animate={false} padding={"menu"}><AboutProfileSheet username={profile} onClose={() => setProfileInfoOpen(false) }/></Sheet>}
            {settingsOpen && <Sheet onClose={() => setSettingsOpen(false) } padding={"menu"}><SettingsSheet onClose={() => setSettingsOpen(false) } /></Sheet>}
            {communityModOpen && <Sheet onClose={() => setCommunityModOpen(false) } padding={"menu"}><CommunityModOptionsSheet community={community} onClose={() => setCommunityModOpen(false) } /></Sheet>}
        </header>
    );
})`
  width: 100%;
  height: ${({theme}) => theme.top.height};
  z-index: 1;

  color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : themecolors.light_high_impact_text};
  background: ${({theme, transparentBackground}) => theme.color.name === 'dark' ? (transparentBackground ? '#121212eb' : '#121212') : (transparentBackground ? '#ffffffc7' : '#ffffff')};
  backdrop-filter: blur(8px);
  
  ${TopBarIconInner} {
    height: 50px;
    display: flex;
    align-items: center;
  }
  ${TopBarIconInner}:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : 'rgba(0,0,0,.06)'};
    border-radius: 50%;
    height: 40px;
    padding: 8px;
  }
  
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: ${({theme}) => theme.top.height};

  ${Title} {
    flex-grow: 1;
    font-weight: 600;
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
  }
  ${LogoTitle} {
    font-family: 'Poppins';
    flex-grow: 1;
    font-weight: 600;
    font-size: 27px;
    letter-spacing: -2px;
  }

  ${Title}:first-child {
    margin-left: 10px;
  }

  ${BareButton} {
    display: flex;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
  }

  ${({border, theme}) => border && `
      border-bottom: ${theme.color.name === 'dark' ? `1px solid ${themecolors.dark_background_5}` : `1px solid #d0cfcf`};
      box-shadow: ${({theme}) => theme.color.name === 'dark' ? '1px 1px 15px 0px #171717' : 'none'};
  `}
  
  ${Search} {
    line-height: initial;
    flex-grow: 1;
  }

  ${Search} input {
    height: 36px;
    font-size: 15px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.light_input};
    border: none;
    border-radius: 8px;
    margin-right: 12px;
    padding: 0 46px;
  }
  
  ${Search} input::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${GroupLeft}, ${GroupRight} {
    display: flex;
    align-items: center;
    padding: 6px;
  }
  ${Search} {
    flex-grow: 1;
  }

  ${Save} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 16px;
    border-radius: 48px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.pure_black};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_black : themecolors.pure_white};
    margin-right: 8px;
  }
  ${Save}:active {
    opacity: 0.7;
  }
`;

export const FixedTopBar = styled(({
                                       className,
                                       title,
                                       back,
                                       settings,
                                       sidebar,
                                       community,
                                       message,
                                       border = true,
                                       postId,
                                       save,
                                       style,
                                       black,
                                       search
                                   }) => {
    return (
        <div className={className}>
            <Wrapper>
                <TopBar search={search} black={black} title={title} back={back} settings={settings} sidebar={sidebar} community={community} message={message} border={border} postId={postId} save={save} />
            </Wrapper>
        </div>
    );
})`
  height: 52px;

  ${TopBar} {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : themecolors.light_high_impact_text};
    height: 50px;
    background-color: ${({theme, black}) => theme.color.name === 'dark' ? (black ? themecolors.dark_background_1 : themecolors.dark_background_1) : theme.white_0};
    background: ${({theme, black}) => theme.color.name === 'dark' ? (black ? themecolors.dark_background_1 : '#121212eb'): 'rgba(255, 255, 255, 0.90)'};
    backdrop-filter: blur(8px);
  }
  
  ${Wrapper} {
    position: fixed;
    z-index: 2;
    width: 100%;
  }
  
`;

export const FadedTopBar = styled(({...props}) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > 60);
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <TopBar {...props} shadow={isScrolled} border transparentBackground />
    );
})`
`;

export default TopBar;
